import { Dialog } from "@headlessui/react";
import * as React from "react";

import { cn } from "@/lib/utils";

const DialogTitle = React.forwardRef<
  React.ElementRef<typeof Dialog.Title>,
  React.ComponentPropsWithoutRef<typeof Dialog.Title> & {
    className?: string;
  }
>(({ className, ...props }, ref) => (
  <Dialog.Title
    ref={ref}
    className={cn(
      "all-small-caps pr-6 text-base uppercase tracking-wider",
      className,
    )}
    {...props}
  />
));

DialogTitle.displayName = Dialog.Title.displayName;

export default DialogTitle;
